import styled from "styled-components";

export const StyledPre = styled.div`
  display: flex;
  height: calc(100vh - 80px);
  padding-top: 80px;
`;
